import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router";
import getCommonResponse from '../actions/Common';


function POC() {
    const {year, title} = useParams();
    const navigate = useNavigate();
    const [pocLink, setPOCLink] = useState(null);

    useEffect(() => {
        const URL = `/api/project/poc/link/${year}/${title}`;
        getCommonResponse.GetDetailsWithApiKey(URL, (response) => {  
            if(response.status == 200) {
                setPOCLink(response.data.link)
            } else if(response.status == 401) {
                navigate("/login")
            }
        });
    }, [])


    return(
        <>
            {pocLink != null && 
                <iframe src={pocLink} style={{width: "100%", height: "100vh", display: "block", overflow: "hidden"}}></iframe>
            }
        </>
    )
}

export default POC;